import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ProductTypeService } from '@http/clients/product-type.service';
import { IBaseDto } from '@http/clients/reporting-app/base-dto.service';
import { ReportsService } from '@services/reports.service';
import { CustomMenuItemComponent } from '@shared/custom-menu-item/custom-menu-item.component';
import { ValidationErrorMessageComponent } from '@shared/validation-error-message/validation-error-message.component';
import { EditorComponentBase, GenericDropdownMultiselectComponent } from 'ngx-lib';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-reporting-opportunity-product-types-editor',
    templateUrl: './reporting-opportunity-product-types-editor.component.html',
    styleUrls: ['./reporting-opportunity-product-types-editor.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [GenericDropdownMultiselectComponent, CustomMenuItemComponent, ValidationErrorMessageComponent]
})
export class ReportingOpportunityProductTypesEditorComponent
    extends EditorComponentBase<number[] | null>
    implements OnInit, OnDestroy
{
    source: IBaseDto[];
    selectedItems?: IBaseDto[];
    subscription?: Subscription;

    constructor(
        private readonly reportsService: ReportsService,
        private readonly productTypeService: ProductTypeService
    ) {
        super();
        this.source = [];
    }

    async ngOnInit(): Promise<void> {
        this.source = await this.productTypeService.search({
            filterText: undefined,
            isActive: true,
            isReserved: undefined
        });
        this.subscription = this.reportsService.selectedProperty$.subscribe(async (ready) => {
            if (
                ready &&
                this.bindingProperty !== null &&
                this.bindingProperty?.length &&
                Array.isArray(this.bindingProperty)
            ) {
                const inactiveIds = this.bindingProperty.filter((id) => !this.source?.some((obj) => obj['id'] === id));
                if (inactiveIds.length > 0) {
                    const archivedItems = await this.productTypeService.getByIds(inactiveIds);
                    this.source = [...(this.source || []), ...archivedItems];
                }
                this.selectedItems = this.source.filter(
                    (obj) => this.bindingProperty?.find((id) => id === obj['id']) !== undefined
                );
            } else if (ready && (this.bindingProperty === null || this.bindingProperty === undefined)) {
                this.selectedItems = [];
            }
        });
    }

    onSelectedItemChange() {
        if (this.selectedItems?.length) {
            this.bindingProperty = this.selectedItems.map((obj) => obj.id);
        } else {
            this.bindingProperty = null;
        }
        this.valueChange.emit();
    }

    ngOnDestroy(): void {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
}
